import { Box, Typography } from '@mui/material';
import Branding from './pages/Branding';

export default function BrandingAndDomain() {
  return (
    <Box sx={{ px: { xs: 2, lg: 6 }, width: '100%', overflowX: 'hidden' }}>
      <Typography
        variant='h6'
        fontWeight={500}
        display='flex'
        alignItems='center'
        gap={1}
        sx={{ fontSize: { xs: '1.125rem', lg: '1.25rem' } }}
      >
        Branding & Domain
      </Typography>
      <Typography mb={{ xs: 2, lg: 3 }} color='secondary' sx={{ fontSize: { xs: '14px', lg: '1rem' } }}>
        Customize your business identity and domain settings.
      </Typography>

      <Branding />
    </Box>
  );
}
